<div class="table-responsive">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    class="table w-100 gy-5 table-row-bordered align-middle"
  >
    @for (column of tableColumns; track column.key) {
      <ng-container [matColumnDef]="column.key">
        <!-- HEADER -->
        @if (column.isSortable) {
          <th
            *matHeaderCellDef
            mat-header-cell
            [mat-sort-header]="column.key"
            arrowPosition="after"
            [ngClass]="{ 'min-w-70px text-center': column.key === 'actions' }"
            class="min-w-125px"
          >
            <app-table-content
              [width]="70"
              [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
            >
              {{ column.title }}
            </app-table-content>
          </th>
        } @else {
          <th
            *matHeaderCellDef
            mat-header-cell
            [ngClass]="{ 'min-w-70px text-center': column.key === 'actions' }"
            class="min-w-125px"
          >
            <app-table-content
              [width]="70"
              [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
            >
              {{ column.title }}
            </app-table-content>
          </th>
        }

        <!-- DATA -->
        <td
          *matCellDef="let element"
          mat-cell
          class="px-3"
          [class.text-center]="column.key === 'actions'"
        >
          @if (column.key === 'actions') {
            <app-table-content
              [count]="1"
              [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
              [type]="'icon'"
              class="text-center"
            >
              <span
                [inlineSVG]="'./assets/media/icons/ic_task.svg'"
                class="svg-icon svg-icon-2 cursor-pointer"
                (click)="onDetail(element)"
              ></span>
            </app-table-content>
          } @else {
            <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
              @switch (column.key) {
                @case ('period') {
                  {{ element.period_start }} s/d <br />
                  {{ element.period_end }}
                }
                @case ('progress') {
                  <div class="d-flex flex-column">
                    {{ element.progress_percentage }}
                    @if (element.level) {
                      <span class="text-gray-700">{{ element.level }}</span>
                    }
                  </div>
                }
                @case ('budget') {
                  @if (element.budget_estimation) {
                    <div class="d-flex flex-column">
                      {{ element.budget_estimation }}
                      @if (element.budget_estimation_percentage) {
                        <span class="text-gray-700">{{
                          element.budget_estimation_percentage
                        }}</span>
                      }
                    </div>
                  } @else {
                    -
                  }
                }
                @case ('status') {
                  <span class="badge badge__status badge__status--{{ element['status_enum'] }}">
                    {{ element.status_string }}
                  </span>
                }
                @default {
                  {{ element[column.key] }}
                }
              }
            </app-table-content>
          }
        </td>
      </ng-container>
    }

    <!-- HEADER ROW -->
    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="fw-bold text-start text-uppercase"
    ></tr>

    <!-- DATA ROW -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
